import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import diacritics from 'diacritics'

import ContentSection from '../../../components/ContentSection'
import { Text, Box, Heading } from 'rebass'
import ContentVehicleMultiCardListing from '../../../components/ContentVehicleMultiCardListing'
import citygateTheme from '../../../theme/'
import LinkRounded from '../../../components/LinkRounded'

import typography from '../../../utils/typography'
import normaliseUsedVehicleForVehicleCard from '../../../../lib/cars/used/used-vehicle-to-card-normaliser'
import themeMap from '../../heading/lib/themes'
import { findCategory } from '../../../../lib/category-matcher'
import { Container } from '../../../utils/style'

const VehicleCarouselWidget = (props) => {
  const {
    make,
    header,
    theme,
    showLettering,
    filter,
    location,
    usedVehicles
  } = props

  const currentTheme = themeMap[theme] || themeMap.light

  const name =
    (make && make.name && make.name) ||
    (make && make.brandName && make.brandName) ||
    ''
  const normalise = (string) => diacritics.remove(string).toLowerCase()
  const filterByMake = (vehicle) => {
    const vehicleBrand = normalise(vehicle.brand)
    const normalisedMake = normalise(name)
    return (
      vehicleBrand.includes(normalisedMake) &&
      findCategory(vehicle.category).type === make.category
    )
  }

  const filterByLocation = (vehicle) => {
    return vehicle.dealership && vehicle.dealership._id === location
  }

  const vehicles = usedVehicles
    ? usedVehicles
        .filter(filter === 'location' ? filterByLocation : filterByMake)
        .slice(0, 10)
    : []

  return usedVehicles.length > 0 ? (
    <ContentSection
      title={showLettering && `Used ${name}`}
      bg={currentTheme.backgroundColour}
      fg={currentTheme.foregroundColour}
      left
    >
      <Box
        mt={[typography.rhythm(2), typography.rhythm(3)]}
        mb={[-30, null, 0]}
        px={20}
      >
        <Heading
          center
          f={[6, 7, 8]}
          mt={typography.rhythm(1)}
          mb={[-40, null, 0]}
          px={60}
          color={currentTheme.foregroundColour || 'white'}
        >
          {header}
        </Heading>
      </Box>
      <ContentVehicleMultiCardListing
        vehicles={vehicles.map(normaliseUsedVehicleForVehicleCard)}
        buttons={false}
        reverse={currentTheme.reversed}
        fixedHeightImage={false}
      />
      {name && (
        <Container maxWidth={citygateTheme.content.max.width} pt={20} pb={80}>
          <Text center as="div">
            <LinkRounded
              to={`/${make.category}s/used?brand=${name.toLowerCase()}`}
              shadow
              thin
              outline
            >
              See all used {name}
            </LinkRounded>
          </Text>
        </Container>
      )}
    </ContentSection>
  ) : null
}

const UsedVehicleCarousel = (props) => {
  const data = graphql`
    {
      allMakeCatfish {
        edges {
          node {
            _id
            brandName
            name
            category
          }
        }
      }
    }
  `

  return (
    <StaticQuery
      query={data}
      render={(data) => <VehicleCarouselWidget data={data} {...props} />}
    />
  )
}

export default UsedVehicleCarousel
